import { ChangeDetectionStrategy, Component, Input, OnChanges } from '@angular/core';
import { ShopStatLine, shopStatLines } from './shop-stats';
import { CultureService } from '../../culture/culture.service';

/// A seller's shop as a card (ShopCard on the server): the shops directory (/shops) and the home page's "Shops to
/// follow". Its cover strip, logo, name, the verified mark, the tagline and the stats, and the whole card leads to the
/// shop's page. The card is the site's own look: a seller's accent colour belongs to their page, not to a list of shops.
@Component({
    selector: 'app-shop-card',
    templateUrl: './shop-card.component.html',
    styleUrls: ['./shop-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShopCardComponent implements OnChanges {
    @Input() shop: any;
    /// The name's heading level: 2 under a page's H1 (the directory), 3 under a block's own heading (the home page).
    @Input() level = 3;

    stats: ShopStatLine[] = [];
    /// The name's first letter, in place of a logo the shop has not given.
    initial = '';

    constructor(private culture: CultureService) { }

    ngOnChanges(): void {
        this.stats = shopStatLines(this.shop && this.shop.Stats, this.culture);
        this.initial = String((this.shop && this.shop.Name) || '').trim().charAt(0).toUpperCase();
    }
}
